import { all } from 'redux-saga/effects';
import authSaga from './modules/auth/authSaga';
import branchSaga from './modules/branch/saga';
import patientRegistrationSaga from './modules/admin/patientRegistartion/saga';
import patientInformationSaga from './modules/admin/patientInformation/saga';
import patientEmergencyContactSaga from './modules/admin/patientEmergencyContactInfo/saga';
import patientInsuranceSaga from './modules/admin/patientInsurance/saga';
import patientPhysicianSaga from './modules/admin/patientPhysician/saga';
import patientMedicalHistorySaga from './modules/admin/patientMedicalHistory/saga';
import patientLifeStyleSaga from './modules/admin/patientLifeStyle/saga';
import patientAcknowledgementSaga from './modules/admin/patientAcknowledgement/saga';
import patientConsentSaga from './modules/admin/patientConsent/saga';
import patientProfileSaga from './modules/admin/patientProfile/saga';
import profileSaga from './modules/profile/saga';
import staffSaga from './modules/staff/saga';
import dashboardSaga from './modules/dashboard/saga';
import homeSaga from './modules/home/saga';
import permissionsSaga from './modules/permissions/saga';

export default function* rootSaga() {
    yield all([
        authSaga(),
        branchSaga(),
        patientRegistrationSaga(),
        patientInformationSaga(),
        patientEmergencyContactSaga(),
        patientInsuranceSaga(),
        patientPhysicianSaga(),
        patientMedicalHistorySaga(),
        patientLifeStyleSaga(),
        patientAcknowledgementSaga(),
        patientConsentSaga(),
        patientProfileSaga(),
        profileSaga(),
        staffSaga(),
        dashboardSaga(),
        homeSaga(),
        permissionsSaga(),
    ]);
}
